module.exports = __webpack_public_path__ + "img/thumnail1.4a3c8312.png";